export default __webpack_public_path__ + "static/media/sensors.4c694258.png";